import React from 'react'

export const NLoader  = props => {

  const color_class = props.color || "pl-light-blue";
  const size_class = props.size || "pl-size-exs";

  return (
      <div className="ncartdropdown-items-loader">
        <div className={`preloader ${size_class}`}>
            <div className={`spinner-layer ${color_class}`}>
                <div className="circle-clipper left">
                    <div className="circle"></div>
                </div>
                <div className="circle-clipper right">
                    <div className="circle"></div>
                </div>
            </div>
        </div>
      </div>
)}

